var _class, _descriptor, _descriptor2;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Service, { inject as service } from '@ember/service';
import { getOwner } from '@ember/application';
import { CDP } from '@squareup/cdp';
import env from '@square/environment-utils/environment';
import { getUrlFlag } from '@square/dashboard-utilities/utils/window';
import { onFirstConsent, hasConsent, OneTrustConsent } from '@square/dashboard-utilities/utils/one-trust/one-trust-compliance';
import { logToConsole } from '@dashboard/user-journeys/utils/user-journey-logging';
export const UJ_CDP_PRODUCTION_API_KEY = '2ed1fd2d-3161-429d-8e5e-c47f62fdb364';
export const UJ_CDP_STAGING_API_KEY = '842efe30-fdd8-4b5a-a887-b377f0283251';
let UserJourneyData = (_class = class UserJourneyData extends Service {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "cdp", void 0);
    // Exposes instance of CDP library for this service's CDP source
    _initializerDefineProperty(this, "userInfo", _descriptor, this);
    _initializerDefineProperty(this, "sentry", _descriptor2, this);
    _defineProperty(this, "track", (eventName, eventProps, options) => {
      if (env().isDevelopment || env().isStaging) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        logToConsole(eventProps);
      }
      if (!this.shouldEnableUserJourneyTracking) {
        return;
      }
      if (!this.cdp) {
        this.sentry.captureException(new Error('Instrumentation not initialized: user-journey-data cdp does not exist'));
        return;
      }
      this.cdp.track(eventName, eventProps, options);
    });
    onFirstConsent(getOwner(this), OneTrustConsent.PERFORMANCE, () => {
      const apiKey = env().isProduction ? UJ_CDP_PRODUCTION_API_KEY : UJ_CDP_STAGING_API_KEY;
      const environment = env().isProduction ? 'production' : 'staging';
      const {
        merchantToken,
        employmentToken,
        personToken
      } = this.userInfo;
      this.cdp = new CDP({
        apiKey,
        environment,
        application: {
          name: 'app-dashboard'
        },
        // Registry app for DS event ownership attribution
        logEventsToConsole: this.logEventsToConsole(),
        useSameOrigin: env().isProduction || env().isStaging
      });
      if (env().isProduction || env().isStaging) {
        this.cdp.identify(merchantToken, 'merchant', {
          merchantToken,
          employmentToken,
          personToken
        });
      }
    });
  }
  willDestroy() {
    this.cdp?.removeEventListeners();
  }
  get shouldEnableUserJourneyTracking() {
    return (env().isProduction || env().isStaging) && hasConsent(OneTrustConsent.PERFORMANCE);
  }
  logEventsToConsole() {
    if (getUrlFlag('logcdp', location)) {
      return 'on';
    }
    if (env().isTesting) {
      return 'off';
    }
    return 'default';
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "userInfo", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "sentry", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export { UserJourneyData as default };